import React, { Component } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

class Loading extends Component {
  render () {
    const { size } = this.props
    return (
      <div id='loading' className='centered'>
        <div
          className='loadingInnerContainer'
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '10%'
          }}
        >
          <h3>{this.props.message}</h3>
          <CircularProgress size={size}/>
        </div>
      </div>
    )
  }
}

Loading.defaultProps = {
  size: 60
}

export default Loading



// WEBPACK FOOTER //
// ./src/widgets/Loading.js